import BaseModel from "../base/baseModel";

export default class PacienteCondicaoModel extends BaseModel {
    id?: number = null;
    pacienteId?: number = null;
    condicaoId?: number = null;
    condicaoDescricao?: string = null;
}
